<template>
	<div class="bg-gray-100 NOTh-screen min-h-full">
		<layout-admin-top-nav />
		<Analytics title="Admin" />
		<clear-session-storage />
		<main>
			<ui-alert
				v-if="flashMessage"
				:type="flashMessage.type"
				:message="flashMessage.message"
			/>
			<slot />
			<layout-modal-container />
		</main>
	</div>
</template>

<script>
import ClearSessionStorage from "../ClearSessionStorage.vue";
export default {
	components: { ClearSessionStorage },
	props: {
		flashMessage: {
			type: Object,
			required: false,
			default: null,
		},
	},
};
</script>
